import React, { Component } from "react";

class AuthorInfo extends React.Component {
  render() {
    return (
      <div className="text-center">
        <div
          className="author-img"
          style={{ backgroundImage: "url(images/avatar2.jpg)" }}
        />
        <h1 id="colorlib-logo">
          <a href="index.html" style={{ fontSize: 40, fontFamily: "Apalu" }}>
            {this.props.myName}
          </a>
        </h1>
        <span className="email">
          <i className="icon-mail" style={{fontSize: 20, marginRight: '8px'}}></i>
          <a href={"mailto:".concat(this.props.myEmail) } style={{fontSize: 16, marginRight: '8px'}}>
            {this.props.myEmail}
          </a>
        </span>
      </div>
    );
  }
}

class PageNavigators extends React.Component {
  constructor(props) {
    super(props);
    const numbers = this.props.parts;
    this.listItems = numbers.map((number) => (
      <li>
        <a
          href={number}
          data-nav-section={number.startsWith("#") ? number.slice(1) : number}
          style={{ fontFamily:  "Quicksand" }}
        >
          {number.startsWith("#") ? number.slice(1) : number} {/* remove "#" when displays*/ }
        </a>
      </li>
    ));
  }
  render() {
    return (
      <nav id="colorlib-main-menu" role="navigation" className="navbar">
        <div id="navbar" className="collapse">
          <ul>{this.listItems}</ul>
        </div>
      </nav>
    );
  }
}

class ExtLinks extends React.Component {
  render() {
    return (
      <nav id="colorlib-main-menu">
        <ul>
          <li>
            <a
              href={this.props.extLinks[0]}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="icon-github"></i>
            </a>
          </li>
          {/* gitee option is deprecated currently */}
        </ul>
      </nav>
    );
  }
}

class FootNotes extends React.Component {
  render() {
    return (
      <div className="colorlib-footer">
        <p>
          <small>
            Made with <i className="icon-heart" aria-hidden="true" /> and{" "}
            <i className="icon-beer" aria-hidden="true"></i>
            <br></br>
            Thanks{" "}
            <a
              href="https://colorlib.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Colorlib
            </a>{" "}
            for inspiration
          </small>
        </p>
      </div>
    );
  }
}

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.parts = [
      "#Introduction",
      "#Timeline",
      "#Projects",
      "#Publications",
      "#Collections",
    ]; // anchors are with #
    this.extLinks = [
      "https://gitee.com/tianfenglu",
      "https://github.com/tianfeng-lu",
    ];
  }
  render() {
    return (
      <div>
        <div>
          <aside id="colorlib-aside" className="border js-fullheight">
            <AuthorInfo
              myName="Tianfeng Lu"
              myEmail="lut@wustl.edu"
            ></AuthorInfo>
            <br />
            <PageNavigators parts={this.parts}></PageNavigators>
            <ExtLinks extLinks={this.extLinks}></ExtLinks>
            <FootNotes></FootNotes>
          </aside>
        </div>
      </div>
    );
  }
}
